/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { CollectionView } from 'backbone.marionette';

import AWPackageContractExtensionView from '../AWPackageContractExtensionView';

const AWPackageContractExtensionCollectionView = CollectionView.extend({

  className: 'command-row-collection-view',

  childView: AWPackageContractExtensionView,

  childViewOptions() {
    return this.model.toJSON();
  },

  childViewEvents: {
    'remove:contract-extension': 'onChildClickRemoveContractExtension'
  },

  onChildClickRemoveContractExtension(childView) {
    this.collection.remove(childView.model);
  },

  getFormData() {
    const formData = [];
    _.each(this.children._views, (childView) => {
      formData.push(childView.getFormData());
    });
    return formData;
  }
});

export default AWPackageContractExtensionCollectionView;
